div {
	/* Position */
	position: relative;

	/* Dimesions */
	height: 100%;
	width: 100%;

	/* Flex */
	display: flex;
	align-items: center;
	justify-content: center;

	box-sizing: border-box;
}

button {
	/* Flex */
	display: flex;
	align-items: center;
	justify-content: center;
	/* Cursor */
	cursor: pointer;
	background-color: var(--card-color);

	/* Dim */
	width: 35px;
	height: 35px;

	/* Border */
	border-radius: 0px 5px 5px 0px;
	border-style: solid;
	border-color: var(--border-color);
	border-width: 1px 1px 1px 1px;
}

button:hover {
	background-color: #00000009;
}

input {
	/* Dimensions */
	height: 23px;
	width: 200px;
	
	/* Spacing */
	padding: 5px;

	/* Border */
	outline: 0;
	border-radius: 5px 0px 0px 0px;
	border-style: solid;
	border-color: var(--border-color);
	border-width: 1px 0px 1px 1px;
}

input:focus {
	border-color: var(--primary-highlight);
}

img {
	height: 20px;
	width: 20px;
}

section {
	/* Flex */
	display: flex;
	flex-direction: column;

	/* Position */
	position: absolute;
	left: 0px;
	top: 99%;
	z-index: 10;

	/* Dimensions */
	width: 100px;
	width: 210px;

	/* Color */
	background-color: var(--card-color);

	/* Border */
	border-radius: 0px 0px 5px 5px;
	border-style: solid;
	border-color: var(--border-color);
	border-width: 0px 1px 0px 1px;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.resultItem {
	display: flex;
	justify-content: flex-start;
	border-width: 0px 0px 1px 0px;
	text-align: start;
	width: 100%;
}

mark {
	background: transparent;
	color: var(--primary-highlight);
}

#clearBtn {
	/* Pos */
	position: absolute;
	top: 6px;
	right: 42px;

	/* Dim */
	height: 24px;
	width: 24px;

	/* Flex */
	display: flex;
	align-items: center;
	justify-content: center;

	/* Color */
	background-color: var(--danger-red);

	/* Border */
	border-radius: 5px;
}

#clearBtn > img {
	height: 16px;
	width: 16px;
}